import { makeStyles } from '@mui/styles';

export const usePanelStyles = makeStyles(() => ({
	root: {
		width: '100%',
		'& > div': {
			minHeight: '400px',
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			padding: '0px',
		},
	},
}));
